/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "1.6.1",
  "gitBuildTime": "2026-06-08T13:41:21.671Z",
  "gitBuildVersion": "1.6.1",
  "gitCommitId": "22ea692",
  "gitCommitIdFull": "22ea6922d368fff227e689d2f5086750ad202739",
  "gitCommitTime": "2026-06-08T13:39:54.000Z",
  "version": "1.6.1-2026-06-08T13:39:54.000Z-(22ea692)"
};
